module.exports = __webpack_public_path__ + "static/media/tooltip-close.fc63a94e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tooltip-close.svg
// module id = 902
// module chunks = 1